/* eslint-disable no-param-reassign */
// Japanese study mode settings.
export const JAStudyModes = Object.freeze({
  DEFAULT: 0,
  KANA: 1,
  ROMAJI: 2,
});

// QuizDirection settings.
export const QuizDirection = Object.freeze({
  All: 'All',
  Forward: 'Forward',
  Reverse: 'Reverse',
});

/**
 * Creates a unique object for each app.
 *
 * @returns {Object}
 */
function getDefaultAppOptions() {
  return {
    quizOptions: {},
    sessionConfig: {
      course: {},
      studyAll: {},
    },
  };
}

/**
 * NOTE: When underscore and lodash merge together, this can be replaced
 * with the merge() method.
 *
 * @param {Object} target
 * @param {Object} src
 * @returns {Object}                  a diff of what was updated
 */
function deepMerge(target, src) {
  const diff = {};

  Object.keys(src).forEach(key => {
    if (target[key] && src[key] && typeof target[key] === 'object' && typeof src[key] === 'object') {
      diff[key] = deepMerge(target[key], src[key]);
    } else if (typeof src[key] !== 'undefined' && src[key] !== target[key]) {
      diff[key] = target[key] = src[key];
    }
  });

  return diff;
}

export class UserSettings {
  constructor(attrs = {}) {
    Object.assign(this, {
      apps: {
        contentVolume: 1,
        effectVolume: 0.4,
        jaStudyMode: JAStudyModes.DEFAULT,
        itemStudy: getDefaultAppOptions(),
        rapidChoice: getDefaultAppOptions(),
        selfAssessment: getDefaultAppOptions(),
        sentenceStudy: getDefaultAppOptions(),
        showTranscription: false,
        typingSound: false,
        typingSpecialCharacters: true,
      },

      global: {
        studyAllLanguage: null,
      },
    });

    deepMerge(this, attrs);
  }

  /**
   * @returns {Boolean}
   */
  isKanaMode() {
    return this.apps.jaStudyMode === JAStudyModes.KANA;
  }

  /**
   * @returns {Boolean}
   */
  isRomajiMode() {
    return this.apps.jaStudyMode === JAStudyModes.ROMAJI;
  }

  /**
   * Does a deep merge of properties passed in.
   *
   * @param {Object} attrs
   * @returns {Object}        a diff on what was updated (useful for sending to server)
   */
  update(attrs = {}) {
    return deepMerge(this, attrs);
  }
}

export default UserSettings;
